module.exports = __webpack_public_path__ + "img/hero-empty.2e1c0e21.webp";